module.exports = __webpack_public_path__ + "static/thpcfarm1-16aa713663cdb091184fca14a580f7e2.jpeg";